import api from '@/services/api'

/**
 * 获取商品列表（批发商）
 */
export function getProductList(wholesalerId) {
  // 使用 ProductController 的接口：GET /api/product/wholesaler/list/{wholesalerId}
  const wid = wholesalerId || localStorage.getItem('stored_wholesaler_id') || 1
  return api.get(`/product/wholesaler/list/${wid}`)
}

/**
 * 创建商品
 */
export function createProduct(data) {
  return api.post('/product', data)
}

/**
 * 批量操作商品
 */
export function batchProductAction(data) {
  return api.post('/wholesaler/products/batch-action', data)
}

/**
 * 批量调价
 */
export function batchUpdatePrice(data) {
  return api.post('/wholesaler/products/batch-update-price', data)
}

/**
 * 获取商品详情
 */
export function getProductDetail(id) {
  return api.get(`/api/wholesaler/products/${id}`)
}

/**
 * 编辑商品
 */
export function updateProduct(id, data) {
  return api.put(`/api/wholesaler/products/${id}`, data)
}
